import React from 'react';
import st from './styles.module.scss';
import { Link } from 'react-router-dom';
import logo from '../../../../assets/images/logo/uwed-logo.svg';
import { useTranslation } from 'react-i18next';

const Logo = () => {
  const { t } = useTranslation();
  return (
    <div className={st.topHeaderLogo}>
      <Link to={'/'} style={{ color: 'unset', textDecoration: 'none', height: 70 }}>
        <div className={`d-flex align-items-center h-100 ${st.logoBackground}`}>
          <span className="navbar-brand d-flex align-items-center">
            <img src={logo} alt="logo" style={{ width: '55px', height: '55px' }} />
          </span>
        </div>
      </Link>
      <h5 className={`mb-1 ${st.headerTitleMobile}`} style={{ color: '#fff' }}>
        {t('career_center')}
      </h5>
    </div>
  );
};

export default Logo;
